import React, { useEffect, useState } from "react";
import callApi from "services/api";
import { setLoading } from "state/slices/loaderSlice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const DistrictReport = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [reportData, setReportData] = useState([]);

  useEffect(() => {
    loadDistrictReport();
  }, []);

  const loadDistrictReport = async () => {
    dispatch(setLoading(true));
    const response = await callApi("/v1/api/district/report", "GET");
    if (response?.success) {
      setReportData(response.body?.body || []);
    }
    dispatch(setLoading(false));
  };

  const total = {
    sentToday: 0,
    sentMTD: 0,
    sentYTD: 0,
    completedToday: 0,
    completedMTD: 0,
    completedYTD: 0,
    pendingToday: 0,
    pendingMTD: 0,
    pendingYTD: 0,
  };

  reportData.forEach((r) => {
    total.sentToday += r.sentToday;
    total.sentMTD += r.sentMTD;
    total.sentYTD += r.sentYTD;
    total.completedToday += r.completedToday;
    total.completedMTD += r.completedMTD;
    total.completedYTD += r.completedYTD;
    total.pendingToday += r.pendingToday;
    total.pendingMTD += r.pendingMTD;
    total.pendingYTD += r.pendingYTD;
  });


  const openCaseList = (district, statusType, period) => {
    navigate("/r-ca", {
      state: {
        filterType: "district",
        districtId: district,
        statusType: statusType,
        period: period,
      },
    });
  };


  const renderCell = (value, bgColor, district, statusType, period) => {
    if (value === 0)
      return <td style={{ backgroundColor: bgColor }} className="text-white">{value}</td>;

    return (
      <td
        style={{ backgroundColor: bgColor, cursor: "pointer", textDecoration: "underline" }}
        className="text-white"
        onClick={() => openCaseList(district, statusType, period)}
      >
        {value}
      </td>
    );
  };

  return (
    <div className="container mb-3">
      <div className="card">
        <div
          className="ms-3 me-3 mt-3 p-2 d-flex justify-content-between"
          style={{ backgroundColor: "#262E3D", borderRadius: "8px" }}
        >
          <div className="d-flex align-items-center">
            <span className="card-title text-white m-0">District Report</span>
          </div>
          <button
            className="btn btn-sm btn-success"
            onClick={() =>
              navigate("/grl", {
                state: { reportType: "DistrictWiseReport" },
              })
            }
          >
            Generate Report
          </button>
        </div>

        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-bordered text-center align-middle table-hover table-striped">
              <thead>
                <tr>
                  <th rowSpan="2" style={{ backgroundColor: "#262E3D" }}>
                    <span className="text-white">District Name</span>
                  </th>
                  <th colSpan="3" style={{ backgroundColor: "#262E3D" }}>
                    <span className="text-white">Cases Sent</span>
                  </th>
                  <th colSpan="3" style={{ backgroundColor: "#262E3D" }}>
                    <span className="text-white">Completed</span>
                  </th>
                  <th colSpan="3" style={{ backgroundColor: "#262E3D" }}>
                    <span className="text-white">Pending</span>
                  </th>
                </tr>
                <tr> <th style={{ backgroundColor: "#262E3D" }} className="text-center align-middle" > <span className="text-white">Today</span> </th> <th style={{ backgroundColor: "#262E3D" }} className="text-center align-middle" > <span className="text-white">MTD</span> </th> <th style={{ backgroundColor: "#262E3D" }} className="text-center align-middle" > <span className="text-white">YTD</span> </th> <th style={{ backgroundColor: "#262E3D" }} className="text-center align-middle" > <span className="text-white">Today</span> </th> <th style={{ backgroundColor: "#262E3D" }} className="text-center align-middle" > <span className="text-white">MTD</span> </th> <th style={{ backgroundColor: "#262E3D" }} className="text-center align-middle" > <span className="text-white">YTD</span> </th> <th style={{ backgroundColor: "#262E3D" }} className="text-center align-middle" > <span className="text-white">Today</span> </th> <th style={{ backgroundColor: "#262E3D" }} className="text-center align-middle" > <span className="text-white">MTD</span> </th> <th style={{ backgroundColor: "#262E3D" }} className="text-center align-middle" > <span className="text-white">YTD</span> </th> </tr>

              </thead>

              <tbody>
                {reportData.map((row, idx) => (
                  <tr key={idx}>
                    <td style={{ backgroundColor: "#FFC000" }} className="text-white">
                      {row.district}
                    </td>

                    {renderCell(row.sentToday, "#00B0F0", row.districtId, "sent", "today")}
                    {renderCell(row.sentMTD, "#00B0F0", row.districtId, "sent", "mtd")}
                    {renderCell(row.sentYTD, "#00B0F0", row.districtId, "sent", "ytd")}

                    {renderCell(row.completedToday, "#00FF90", row.districtId, "completed", "today")}
                    {renderCell(row.completedMTD, "#00FF90", row.districtId, "completed", "mtd")}
                    {renderCell(row.completedYTD, "#00FF90", row.districtId, "completed", "ytd")}

                    {renderCell(row.pendingToday, "#FF4D4D", row.districtId, "pending", "today")}
                    {renderCell(row.pendingMTD, "#FF4D4D", row.districtId, "pending", "mtd")}
                    {renderCell(row.pendingYTD, "#FF4D4D", row.districtId, "pending", "ytd")}
                  </tr>
                ))}
              </tbody>

              {/* ---------- TOTAL ROW ---------- */}
              <tr>
                <td style={{ backgroundColor: "#262E3D" }} className="text-white">Total:</td>
                <td style={{ backgroundColor: "#262E3D" }} className="text-white">{total.sentToday}</td>
                <td style={{ backgroundColor: "#262E3D" }} className="text-white">{total.sentMTD}</td>
                <td style={{ backgroundColor: "#262E3D" }} className="text-white">{total.sentYTD}</td>
                <td style={{ backgroundColor: "#262E3D" }} className="text-white">{total.completedToday}</td>
                <td style={{ backgroundColor: "#262E3D" }} className="text-white">{total.completedMTD}</td>
                <td style={{ backgroundColor: "#262E3D" }} className="text-white">{total.completedYTD}</td>
                <td style={{ backgroundColor: "#262E3D" }} className="text-white">{total.pendingToday}</td>
                <td style={{ backgroundColor: "#262E3D" }} className="text-white">{total.pendingMTD}</td>
                <td style={{ backgroundColor: "#262E3D" }} className="text-white">{total.pendingYTD}</td>
              </tr>

            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DistrictReport;
